// extracted by mini-css-extract-plugin
export default {"colorContainer":"AssetColorBox_colorContainer__v5aT-"};